export default function QuestionHover() {
    return (
        <svg className="hover" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9 16.25C12.7279 16.25 15.75 13.2279 15.75 9.5C15.75 5.77208 12.7279 2.75 9 2.75C5.27208 2.75 2.25 5.77208 2.25 9.5C2.25 13.2279 5.27208 16.25 9 16.25Z"
                fill="#949494"
            />
            <path
                d="M6.81738 7.25006C6.99371 6.74881 7.34175 6.32614 7.79985 6.05691C8.25795 5.78768 8.79655 5.68926 9.32027 5.77909C9.84398 5.86893 10.319 6.1412 10.6612 6.54771C11.0034 6.95421 11.1907 7.4687 11.1899 8.00006C11.1899 9.50006 8.93988 10.2501 8.93988 10.2501V11.3751"
                stroke="white"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9 13.25H9.0075" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
